export const getErrorMessage = async (response: Response): Promise<string> => {
	try {
		const json = await response.json();
		return json.errorMessages[0] || '';
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		return '';
	}
};
